// components
import { Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useCRMembershipStatusPage } from "containers/CRMembershipStatus/useCRMembershipStatusPage";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";

import styles from "containers/CRMembershipStatus/CRMembershipStatusPage.module.css";

// constants
import { CR_MEMBERSHIP_STATUS as Constants, PageTitles } from "constants/global";

const CRMembershipStatusPage = () => {
	const { proceedToSuspendCRMembershipStatus, proceedToUnsuspendCRMembershipStatus, loading, form, externalId, remarks, handleExternalId, handleRemarks } =
		useCRMembershipStatusPage();

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title={Constants.PAGE_HEADER} subTitle={Constants.PAGE_SUBHEADER} />
			<div className={styles?.root}>
				<Head>{PageTitles.CR_MEMBERSHIP_STATUS}</Head>
				<Form className={styles?.form} form={form} requiredMark={false} layout="horizontal">
					<Form.Item label={<Label requiredMark={true} label={Constants.EXTERNAL_ID_LABEL} classes={{ label: styles?.basic_input_label }} />} name={Constants.EXTERNAL_ID_LABEL}>
						<Input className={styles?.input_field} placeholder={Constants.EXTERNAL_ID_LABEL_PLACEHOLDER} value={externalId} onChange={(e) => handleExternalId(e)} />
					</Form.Item>
					<Form.Item label={<Label requiredMark={false} label={Constants.REMARKS_LABEL} classes={{ label: styles?.basic_input_label }} />} name={Constants.REMARKS_LABEL}>
						<Input.TextArea
							style={{ marginLeft: 117, minWidth: 400 }}
							className={styles?.input_field}
							placeholder={Constants.REMARKS_LABEL_PLACEHOLDER}
							value={remarks}
							onChange={(e) => handleRemarks(e)}
							size="large"
						/>
					</Form.Item>
				</Form>
				<div className={styles.buttonWrapper}>
					<Button label={Constants.SUSPEND_BUTTON_LABEL} type={externalId ? "activeLong" : "disabledLong"} onClick={proceedToSuspendCRMembershipStatus} />
					<Button label={Constants.UNSUSPEND_BUTTON_LABEL} type={externalId ? "activeLong" : "disabledLong"} onClick={proceedToUnsuspendCRMembershipStatus} />
				</div>
			</div>
		</div>
	);
};

export default CRMembershipStatusPage;
